import { render, staticRenderFns } from "./Anticheat.vue?vue&type=template&id=ca3ce834&scoped=true"
import script from "./Anticheat.vue?vue&type=script&lang=js"
export * from "./Anticheat.vue?vue&type=script&lang=js"
import style0 from "./Anticheat.vue?vue&type=style&index=0&id=ca3ce834&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca3ce834",
  null
  
)

export default component.exports